/* eslint-disable no-unused-vars */
/**
 * Import 3rd party packages
 */
import '../scss/blog-single.scss';

/**
 * Import modules / classes
 */
import Lightbox from './modules/Lightbox';
import PageScroll from './modules/PageScroll';

/**
 * Instantiate a new object using imported modules/classes
 */
document.addEventListener('DOMContentLoaded', () => {
    const myLightbox = new Lightbox();
    const myPageScroll = new PageScroll();
});
